export default __webpack_public_path__ + "static/mission-916fa54b718950353308f67ee3462c89.jpg";